import React from 'react';
import { NavLink } from 'react-router-dom';
import { menuItems } from '../menuItems';

const BUBBLES_IMG = 'https://santaplaya-bucket.s3.amazonaws.com/Bubbles.webp';

const NavLinks: React.FC = () => {
  return (
    <nav className="font-prosto mt-24 mr-4">
      <ul className="flex items-center space-x-6">
        {menuItems.map((item) => (
          <li key={item.name} className="relative group">
            {/* The link itself */}
            <NavLink
              to={item.path}
              className="text-sea hover:text-maroon transition-colors text-xs"
            >
              {item.name}
              {/* The bubble image that appears on hover, only on md+ */}
              <img
                src={BUBBLES_IMG}
                alt="Bubbles"
                className="
                hidden 
                md:block
                absolute 
                bottom-full
                left-1/2 
                -translate-x-1/2 
                mb-2
                w-6 h-auto
                opacity-0
                group-hover:opacity-100
                transition-opacity 
                duration-200
              "
              />
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default NavLinks;
